import type { ElementType } from 'react';
import { Accordion } from './components/Accordion';
import { AccordionItem } from './components/AccordionItem';
import { BainGenericContainer } from './components/BainGenericContainer';
import { BackToTopLink } from './components/BackToTopLink';
import { BankingCalculator } from './components/BankingCalculator';
import { Column } from './components/Columns/Column';
import { Columns } from './components/Columns/Columns';
import { Container } from './components/Container';
import { ContentHeading } from './components/ContentHeading';
import { ContentImage } from './components/ContentImage';
import { ContentSection } from './components/ContentSection';
import { Divider } from './components/Divider';
import { Document } from './components/Document';
import { Infogram } from './components/Embeds/Infogram';
import { ExpandCard } from './components/ExpandCard';
import { FirstPersonPerspective } from './components/FirstPersonPerspective';
import { FirstPersonPerspectiveItem } from './components/FirstPersonPerspectiveItem';
import { Li } from './components/Li';
import { Link } from './components/Link';
import { List } from './components/List';
import { MarketplaceField } from './components/MarketplaceField';
import { NerdTip } from './components/NerdTip';
import { NWVerifiedContainer } from './components/NWVerifiedContainer';
import { SMBInfoGatheringCta } from './components/SMBInfoGatheringCta';
import { SMBProsAndConsTable } from './components/SMBProsAndConsTable';
import { SMBWhyTrustNerdWallet } from './components/SMBWhyTrustNerdWallet/SMBWhyTrustNerdWalletAccordion';
import { SMBWhyTrustNerdWalletBullet } from './components/SMBWhyTrustNerdWallet/SMBWhyTrustNerdWalletBullet';
import { Spacer } from './components/Spacer';
import { StarRatingCategories } from './components/StarRatingCategories';
import { Type } from './components/Type';
import { Well } from './components/Well';
import { WPBlock } from './components/WPBlock';
import { WPTable } from './components/WPTable';
import { WPVideo } from './components/WPVideo';

export const STRUCTURED_CONTENT_COMPONENTS: Record<string, ElementType> = {
  Accordion,
  AccordionItem,
  BainGenericContainer,
  BackToTopLink,
  BankingCalculator,
  Columns,
  Column,
  Container,
  ContentHeading,
  ContentImage,
  ContentSection,
  ExpandCard,
  FirstPersonPerspective,
  FirstPersonPerspectiveItem,
  Divider,
  Document,
  Infogram,
  MarketplaceField,
  NerdTip,
  Li,
  Link,
  List,
  NWVerifiedContainer,
  SMBInfoGatheringCta,
  SMBProsAndConsTable,
  SMBWhyTrustNerdWallet,
  SMBWhyTrustNerdWalletBullet,
  Spacer,
  StarRatingCategories,
  Type,
  Well,
  WPBlock,
  WPTable,
  Video: WPVideo,
};
